import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Nav, NavItem, NavLink,
  TabContent, TabPane,
  Row, Col
} from "reactstrap"
import classNames from "classnames"

const Pills = ({  items,
  defaultActive,
  showExpandToggle = true,
  defaultExpanded = false,
  maxHeight
}) => {
  const [active, setActive] = useState(defaultActive || items[0]?.id)
  const [expanded, setExpanded] = useState(defaultExpanded)

  const contentStyle = maxHeight
    ? { maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight, overflow: "auto" }
    : undefined

  return (
    <div>
      <Row className="align-items-center g-2">
        <Col xs="12" md="8">
          {!expanded && (
            <Nav pills>
              {items.map(it => (
                <NavItem key={it.id}>
                  <NavLink
                    href="#"
                    onClick={e => { e.preventDefault(); setActive(it.id) }}
                    className={classNames({ active: active === it.id })}
                  >
                    {it.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          )}
        </Col>

        {showExpandToggle && (
          <Col xs="12" md="4" className="d-flex justify-content-md-end align-items-center mt-2 mt-md-0">
            <span className="me-2 medium text-muted">Expanded View:</span>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="flatToggle"
                checked={expanded}
                onChange={e => setExpanded(e.target.checked)}
                style={{
                  width: '3rem',
                  height: '1.5rem',
                  cursor: 'pointer'
                }}
              />
              <label 
                className="form-check-label ms-2 small" 
                htmlFor="flatToggle"
                style={{cursor: 'pointer'}}
              >
              </label>
            </div>
          </Col>
        )}
      </Row>

      <div className="mt-3" style={contentStyle}>
        {expanded ? (
          // Show all
          <>
            {items.map(it => (
              <div key={`all-${it.id}`} className="mb-4">
                <h6 className="mb-2 text-muted fw-semibold">{it.label}</h6>
                {it.render()}
              </div>
            ))}
          </>
        ) : (
          // Only Show Active One
          <TabContent activeTab={active}>
            {items.map(it => (
              <TabPane key={it.id} tabId={it.id}>
                {active === it.id && it.render()}
              </TabPane>
            ))}
          </TabContent>
        )}
      </div>
    </div>
  )
}

Pills.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    render: PropTypes.func.isRequired,
  })).isRequired,
  defaultActive: PropTypes.string,
  showExpandToggle: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Pills